var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{attrs:{"data":_vm.detail.toService}},[_c('el-table-column',{attrs:{"label":"编号","prop":"serialNumber"}}),_c('el-table-column',{attrs:{"label":"标题","prop":"title"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }